<div class="text-view-dialog">
  <h2 mat-dialog-title *ngIf="title">{{ title }}</h2>
  <mat-dialog-content>
    <p class="text-view-content">{{ text }}</p>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-button (click)="close()">Close</button>
  </mat-dialog-actions>
</div>
